import { Directive, inject, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { UiPageChromeService } from './page-chrome.service';

/**
 * Declara contenido justo antes de la zona derecha de la barra de título.
 *
 * @example
 * ```html
 * <ng-template uiPageTitleBeforeEnd>
 *   <span>Estatus autorización</span>
 * </ng-template>
 * ```
 */
@Directive({
  selector: 'ng-template[uiPageTitleBeforeEnd]',
})
export class UiPageTitleBeforeEndDirective implements OnInit, OnDestroy {
  private readonly template = inject<TemplateRef<unknown>>(TemplateRef);
  private readonly chrome = inject(UiPageChromeService);

  ngOnInit(): void {
    this.chrome.registerTitleBeforeEnd(this.template);
  }

  ngOnDestroy(): void {
    this.chrome.releaseTitleBeforeEnd(this.template);
  }
}
